export const GET_RECIPIENTS_SUMMARY_WATCHER =
  "app/MeasurementImportRecipientsSummary/GET_RECIPIENTS_SUMMARY_WATCHER"
export const GET_RECIPIENTS_SUMMARY_SUCCESS =
  "app/MeasurementImportRecipientsSummary/GET_RECIPIENTS_SUMMARY_SUCCESS"
export const GET_RECIPIENTS_SUMMARY_FAILED =
  "app/MeasurementImportRecipientsSummary/GET_RECIPIENTS_SUMMARY_FAILED"

export const UPLOAD_TEMPLATE_RECIPIENTS_WATCHER =
  "app/MeasurementImportRecipientsSummary/UPLOAD_TEMPLATE_RECIPIENTS_WATCHER"
export const UPLOAD_TEMPLATE_RECIPIENTS_SUCCESS =
  "app/MeasurementImportRecipientsSummary/UPLOAD_TEMPLATE_RECIPIENTS_SUCCESS"
export const UPLOAD_TEMPLATE_RECIPIENTS_FAILED =
  "app/MeasurementImportRecipientsSummary/UPLOAD_TEMPLATE_RECIPIENTS_FAILED"

export const SAVE_EXCEL_RECIPIENTS_WATCHER =
  "app/MeasurementImportRecipientsSummary/SAVE_EXCEL_RECIPIENTS_WATCHER"
export const SAVE_EXCEL_RECIPIENTS_SUCCESS =
  "app/MeasurementImportRecipientsSummary/SAVE_EXCEL_RECIPIENTS_SUCCESS"
export const SAVE_EXCEL_RECIPIENTS_FAILED =
  "app/MeasurementImportRecipientsSummary/SAVE_EXCEL_RECIPIENTS_FAILED"
export const SAVE_EXCEL_RECIPIENTS_PROGRESS =
  "app/MeasurementImportRecipientsSummary/SAVE_EXCEL_RECIPIENTS_PROGRESS"
